export default "__VITE_ASSET__BhHoBnrE__"